import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CanActivate, Router } from '@angular/router';
import { UserRoleService } from '@services/user-role.service';
import { Observable, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ExportInquiryDataGuard implements CanActivate {
    private userRoleService = inject(UserRoleService);
    private router = inject(Router);
    private destroyRef = inject(DestroyRef);

    canActivate(): Observable<boolean> {
        return this.userRoleService.isExportInquiryDataFeatureAvailable().pipe(
            tap((isRotationFeatureAvailable) => {
                if (!isRotationFeatureAvailable) {
                    this.router.navigate(['/not-found']);
                }
                return true;
            }),
            takeUntilDestroyed(this.destroyRef),
        );
    }
}
